import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "../lib/api";

export function useMapsLink(mapsLink, setForm) {
  const [resolving, setResolving] = useState(false);
  useEffect(() => {
    const link = mapsLink.trim();
    if (!/maps\.app\.goo\.gl|google\.[a-z.]+\/maps|^-?\d+\.\d+\s*,\s*-?\d+\.\d+$/.test(link)) return;
    let cancelled = false;
    setResolving(true);
    api.post("/utils/resolve-location", { url: link }).then((response) => {
      if (cancelled) return;
      setForm((form) => ({ ...form, lat: String(response.data.lat), lng: String(response.data.lng) }));
      toast.success(`GPS filled from link: ${response.data.lat}, ${response.data.lng}`);
    }).catch((error) => { if (!cancelled) toast.error(errMsg(error)); })
      .finally(() => { if (!cancelled) setResolving(false); });
    return () => { cancelled = true; };
  }, [mapsLink, setForm]);
  return resolving;
}
